export const entityEndpoints = {
  GET_ENTITIES: '/accounts/',
  GET_ENTITY: '/accounts/:entityId/',
  GET_ENTITY_TYPES: '/accounts/account-types/',
  CREATE_ENTITY: '/accounts/',
  UPDATE_ENTITY: '/accounts/:entityId/',
}
